<template>
    <div class="indexpage bg" :class="{'bgruleHei':show_menu==1}">
      <v-nav @showDownMenu="showDownMenu" class="mobilenav"></v-nav>
      <mode class="modeapp" v-if="loadMode"></mode>
      <div class="banner" v-if="pageshow">
        <div class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../assets/images/phone/banner1.jpg">
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/phone/banner2.jpg">
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/phone/banner3.jpg">
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/phone/banner4.jpg">
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div >
      <div class="index_content" v-if="pageshow">
        <div class="word">
          <p>
            我等众生，从无始旷劫以来，迷失自己本来面目，认妄为真，唤奴作郎，妄起贪嗔，造业受报，如春蚕作茧，自缠自缚，无解脱时。愚者无知，安受困苦，不求解脱；智者虽知生死事大，苦海无边，欲求解脱而苦无其门。
          </p>
          <p>
            释迦文佛，悲悯众生，出苦无由，应现世间，教化众生。一切佛教经论，所有法门，无不围绕着这一中心——明心见性——来阐扬发明，使人们得以觉破迷情，消除无明，离妄返真，就路归家。
          </p>
          <p>
            择其简速易行，与禅相近者，又莫如“心中心密法”。以该法是无相密，无有繁复仪轨，不须建立坛场，任何人随时随地俱可修习，而且不用转弯抹角，修持加行，从有相过渡到无相，可以直接证体起用。故世人尝赞之为禅密，语虽不当，义有足多者。
          </p>
        </div>
        <div class="book">
          <div class="title">最新图书</div>
          <div class="book_list">
            <div class="book_item" v-for="item in bookList" @click="readBook(item)">
              <div class="book_img">
                <img :src="item.image" :alt="item.className">
              </div>
              <div class="book_title textover">《{{item.className}}》</div>
            </div>
          </div>
        </div>
        <div class="book introduce">
          <div class="title">祖师简介</div>
          <div class="book_list introduce_list">
            <div class="book_item user_item" v-for="(item,index) in userList">
              <div class="book_img user_item_img" @click="detailIntroduce(index)">
                <img :src="item.img" :alt="item.nick_name">
              </div>
              <div class="book_title username textover">{{item.nick_name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-if="!pageshow">
        <div class="network">
          <div class="netwrokinner">
            <img src="../../assets/images/network.png" alt="404">
            <div class="networktxt">提示：该网址暂时不能正常访问，建议您稍后再试</div>
          </div>
        </div>
      </div>
      <!--<v-phoneFoot></v-phoneFoot>-->
    </div>
</template>

<script>
    import mode from '@/components/bg/mode'
    import Swiper from '../../../public/swiper/swiper-bundle.min';
    export default {
        name: "index",
        components:{
          mode
        },
        data() {
            return {
              show_menu:0,
              bookList:[],
              userList:[],
              loadMode:true,
              pageshow:true
            }
        },
        mounted() {
          console.log(this.$http)
          var swiper = new Swiper(".swiper", {
            pagination: {
              el: ".swiper-pagination",
              bulletClass : 'swiper-pagination-bullet bullColor',
              bulletActiveClass: 'bullet-active-current_index',
            },
          });
          this.getBook();
        },
        methods: {
          showDownMenu(data){
           if(data==0){
             this.show_menu=0
           }else{
             this.show_menu=1
           }
          },
          getUserList(){
            this.$http({
              url: '/Ancestor/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.loadMode=false
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                res.data.data.map((item,index,arr)=>{
                  if(index<3){
                    this.userList.push(item)
                  }
                })
                console.log(this.userList)
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
            .catch((error) => {
              this.loadMode=false
              console.log(error)
            })
          },
          getBook(){
            this.$http({
              url: '/Book/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {class_name:'',page:1}
            }).then((res) => {
              this.loadMode=false
              this.getUserList()
              console.log(res)
              if(res.data.code==0){
                res.data.data.data.map((item,index,arr)=>{
                  if(index<3){
                    this.bookList.push(item)
                  }
                })
                console.log(this.bookList)
              }else{
                // this.$layer.msg(res.data.msg)
              }
            })
            .catch((error) => {
              console.log(error)
            })
          },
          readBook(item){
            console.log(item)
            // this.$router.push({name:'appbookdetail',params:{id:item.id}})
            this.$router.push({name:'appbookdetail',params:{id:item.id}})
            // window.location.href=item.pdf_content
          },
          detailIntroduce(index){
            this.$router.push({name:'appintroduce',query:{id:index}})
          }
        }
    }
</script>
<style>
  .mobilenav{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index:10;
  }
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow-y: auto;
    background-size:100% 100%;
  }
  .bgruleHei{
    height:100%;
    overflow: hidden;
  }
  .bullColor{
    width:5px !important;
    height:5px !important;
    border-radius:100% !important;
    background: #d0ba9c !important;
    opacity: 1 !important;
  }
  .bullet-active-current_index{
    width:15px !important;
    height:5px !important;
    border-radius:2.5px !important;
    opacity: 1 !important;
    background:#a47129 !important;
  }
</style>
<style scoped lang="scss">
  /*404*/
  .network{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    .netwrokinner{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height:100%;
      .networktxt{
        text-align: center;
        font-size:0.16rem;
        color:#999;
      }
    }
  }
  .banner{
    padding-top:1rem;
    .swiper-slide{
      /*height:3.99rem;*/
      img{
        width:100%;
        /*height:3.99rem;*/
        display: block;
      }
    }
  }
  .index_content{
    padding:0 0.28rem 0.5rem;
    width:100%;
    box-sizing: border-box;
    .word{
      padding:0.3rem 0 0.3rem;
      p{
      text-indent: 2em;
      font-size:0.28rem;
      color:#333;
    }
   }
  .book{
    width:100%;
    .title{
      color:#5f4009;
      font-size:0.32rem;
    }
    .book_list{
      display: flex;
      /*justify-content: space-between;*/
      padding:0.3rem 0 0;
      width:100%;
      .book_item{
        width:33.33%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .book_img{
          width: 1.56rem;
          height:2.33rem;
          img{
            display: block;
            width: 1.56rem;
            height:2.33rem;
          }
        }
        .book_title{
          color:#333;
          font-size:0.24rem;
          text-align: center;
          width:100%;
          padding-top:0.1rem;
        }
      }
    }
  }
  .introduce{
    padding-top:0.4rem;
    .introduce_list{
      .user_item{
        .user_item_img{
          width:1.6rem !important;
          height:2.22rem !important;
          img{
            width:1.6rem !important;
            height:2.22rem !important;
            display: block;
            object-fit: cover;
          }
        }
        .username{
          font-size:0.28rem;
          color:#5f4009;
        }


      }
    }


  }

  }
</style>



// WEBPACK FOOTER //
// src/views/m/index.vue